import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ module, requiredAccess, children }) => {
  // Retrieve module access from sessionStorage
  const moduleAccess = JSON.parse(sessionStorage.getItem('module_access') || '{}');

  // Check if the user has the required access for the specified module
  const hasAccess = moduleAccess[module] === requiredAccess;

  // If no access, redirect to an unauthorized page or login
  if (!hasAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Render the children or Outlet for nested routes
  return children ? children : <Outlet />;
};

export default ProtectedRoute;